import React,{useState, lazy, Suspense} from "react"
// import Sidebar from './components/Sidebar'
// import Content from './components/Content'

const Sidebar = lazy(() => import('./components/Sidebar'));
const Content = lazy(() => import('./components/Content'));

const renderLoader = () => <></>;

const App = () => {
	const [menu,setMenu] = useState('indicators');
	const [view,setView] = useState('list');
	return (
		<div id="indicators-block">

			<Suspense fallback={renderLoader()}>
				<Sidebar menu={menu} setMenu={setMenu} setView={setView} />
			</Suspense>

			<Suspense fallback={renderLoader()}>
				<Content menu={menu} setMenu={setMenu} view={view} setView={setView} />
			</Suspense>

		</div>
	);

}

export default App;
